import React from "react"
import { useDialog } from "../../../context/DialogContext"
import GameDialog from "../components/dialogs/GameDialog"
import JoinConfirmDialog from "../components/dialogs/JoinConfirmDialog"
import { TournamentResultDialog } from "../components/dialogs/TournamentResultDialog"

/**
 * Инкапсулирует оркестрацию диалогов турнира (join / game / result),
 * убирая дублирование openGameDialog / openResultDialog / createDialog
 * из TournamentCard, Overview, TournamentDetailsPage и PaymentSuccessDialog.
 *
 * @param {object} params
 * @param {object} params.tournament - Объект турнира.
 * @param {object} params.user - Текущий пользователь.
 * @returns {{ openJoin: Function, openGame: Function, openResult: Function }}
 */
export const useTournamentDialogs = ({ tournament, user }) => {
  const [openJoinDialog, closeJoinDialog] = useDialog()
  const [openGameDialog, closeGameDialog] = useDialog()
  const [openTournamentResultDialog, closeTournamentResultDialog] = useDialog()

  const tournamentId = tournament?.id

  const openResult = (result = {}) => {
    openTournamentResultDialog({
      children: (
        <TournamentResultDialog
          closeDialog={closeTournamentResultDialog}
          playAgain={openGame}
          zombiesKilled={result.zombiesKilled}
          waveReached={result.waveReached}
          bossesKilled={result.bossesKilled}
          score={result.score}
          timePlayed={result.timePlayed}
          position={result.position}
          totalPlayers={result.totalPlayers}
          bestScore={result.bestScore}
          variant={result.variant || "complete"}
        />
      ),
    })
  }

  const openGame = () => {
    openGameDialog({
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
      children: (
        <GameDialog
          tournamentId={tournamentId}
          user={user}
          closeDialog={closeGameDialog}
          onGameFinished={openResult}
        />
      ),
    })
  }

  const openJoin = () => {
    openJoinDialog({
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
      children: (
        <JoinConfirmDialog
          closeDialog={closeJoinDialog}
          tournament={tournament}
          user={user}
        />
      ),
    })
  }

  return { openJoin, openGame, openResult }
}
